import styled from "styled-components";
import { useState, useEffect } from "react";
import FormStringInput from "../../../../../../components/FormControls/FormStringInput";
import FormSelectWithLabel from "../../../../../../components/FormControls/FormSelectWithLabel";
import PrimaryButton from "../../../../../../components/FormControls/PrimaryButton";
import WarningButton from "../../../../../../components/FormControls/WarningButton";
import request from "../../../../../../api/request";
import MessageBox from "../../../../../../components/MessageBox";
import { NotificationManager } from 'react-notifications';

const StyledTreasureSettings = styled.div`
`;

const WhiteBoard = styled.div`
    background-color: white;
    width: 600px;
    box-sizing: border-box;
    min-height: 543px;
    padding: 30px;
    margin-bottom: 30px;
    color: ${(props) => props.theme.color.gray};
`;

const Title = styled.span`
    display: block;
    color: ${(props) => props.theme.color.primaryblue};
    font-size: 14px;
    font-weight: 600;
    padding-bottom: 5px;
`;

function TreasureSettings(props) {

    const {branches, selectedBranch, regionsList, refreshBranchesCallback} = props;

    let currentYear = new Date().getFullYear();
    const [showMessageBox, setShowMessageBox] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [treasureTitle, setTreasureTitle] = useState('Mr.');
    const [treasureSurname, setTreasureSurname] = useState('');
    const [treasureForename, setTreasureForename] = useState('');
    const [treasurePhone, setTreasurePhone] = useState('');
    const [treasureEmail, setTreasureEmail] = useState('');
    const [treasureAddress1, setTreasureAddress1] = useState('');
    const [treasureAddress2, setTreasureAddress2] = useState('');
    const [treasureAddress3, setTreasureAddress3] = useState('');
    const [treasureAddress4, setTreasureAddress4] = useState('');
    const [treasureAddress5, setTreasureAddress5] = useState('');
    
    const [needsValidation, setNeedsValidation] = useState(false);

    let callingTitles = ['Mr.', 'Mrs.', 'Miss.', 'Ms.', 'Dr.', 'Prof.', 'Sir', 'The Rev.', 'The Hon.'];

    const onSaveChanges = async () => {
        setIsSaving(true);
        let branchData = {};
        branchData.RecordType = selectedBranch.RecordType;
        branchData.BranchCommitteeCode = selectedBranch.BranchCommitteeCode;
        branchData.RecordName = selectedBranch.RecordName;
        branchData.DivisionCode = selectedBranch.DivisionCode;
        branchData.TreasurerTitle = treasureTitle;
        branchData.TreasurerSurname = treasureSurname.length ? treasureSurname : null;
        branchData.TreasurerForenames = treasureForename.length ? treasureForename : null;
        branchData.TreasurerPhone = treasurePhone.length ? treasurePhone : null;
        branchData.TreasurerEmail = treasureEmail.length ? treasureEmail : null;
        branchData.TreasurerAddress1 = treasureAddress1.length ? treasureAddress1 : null;
        branchData.TreasurerAddress2 = treasureAddress2.length ? treasureAddress2 : null;
        branchData.TreasurerAddress3 = treasureAddress3.length ? treasureAddress3 : null;
        branchData.TreasurerAddress4 = treasureAddress4.length ? treasureAddress4 : null;
        branchData.TreasurerAddress5 = treasureAddress5.length ? treasureAddress5 : null;

        const resp = (await request('database', 'updateBranchTreasure', [branchData]));
        if (resp.ok && refreshBranchesCallback) {
            refreshBranchesCallback(selectedBranch.BranchCommitteeCode, selectedBranch.RecordType);
            NotificationManager.success('Updated treasurer details');
        } else
        {
            console.log(resp.data);
            NotificationManager.error(resp.data);
        }
        setIsSaving(false);
    };

    const deleteBranch = async () => {
        setShowMessageBox(false);

        setIsDeleting(true);
        let deleteData = {};
        deleteData.RecordType = selectedBranch.RecordType;
        deleteData.RecordName = selectedBranch.RecordName;
        deleteData.BranchCommitteeCode = selectedBranch.BranchCommitteeCode;
        const resp = (await request('database', 'deleteBranch', [deleteData]));
        if (resp.ok && refreshBranchesCallback) {
            refreshBranchesCallback();
            NotificationManager.success('Branch deleted');
        } else
        {
            console.log(resp.data);
            NotificationManager.error(resp.data);
        }
        setIsDeleting(false);
    }

    useEffect(() => {
        if (selectedBranch) {
            setNeedsValidation(false);
            setTreasureTitle(selectedBranch.TreasurerTitle ? selectedBranch.TreasurerTitle : '');
            setTreasureSurname(selectedBranch.TreasurerSurname ? selectedBranch.TreasurerSurname : '');
            setTreasureForename(selectedBranch.TreasurerForenames ? selectedBranch.TreasurerForenames : '');
            setTreasurePhone(selectedBranch.TreasurerPhone ? selectedBranch.TreasurerPhone : '');
            setTreasureEmail(selectedBranch.TreasurerEmail ? selectedBranch.TreasurerEmail : '');
            setTreasureAddress1(selectedBranch.TreasurerAddress1 ? selectedBranch.TreasurerAddress1 : '');
            setTreasureAddress2(selectedBranch.TreasurerAddress2 ? selectedBranch.TreasurerAddress2 : '');
            setTreasureAddress3(selectedBranch.TreasurerAddress3 ? selectedBranch.TreasurerAddress3 : '');
            setTreasureAddress4(selectedBranch.TreasurerAddress4 ? selectedBranch.TreasurerAddress4 : '');
            setTreasureAddress5(selectedBranch.TreasurerAddress5 ? selectedBranch.TreasurerAddress5 : '');
        }
    }, [selectedBranch, branches]);

    return (
        <StyledTreasureSettings>
            <WhiteBoard>
                <Title>Treasure</Title>
                <FormSelectWithLabel label='Title' items={callingTitles} value={treasureTitle} onChange={(e) => setTreasureTitle(e.target.value)} style={{width:150, height:35, paddingLeft:13}}></FormSelectWithLabel>
                <div style={{display:'flex'}}>
                    <FormStringInput label='Surname' value={treasureSurname} onChange={(val) => setTreasureSurname(val)} inputStyle={{width:245}}></FormStringInput>
                    <FormStringInput label='Forename' value={treasureForename} onChange={(val) => setTreasureForename(val)} inputStyle={{width:245}} style={{marginLeft: 15}}></FormStringInput>
                </div>
                <Title style={{marginTop:30}}>Contact details</Title>
                <div style={{display:'flex'}}>
                    <FormStringInput label='Telephone' value={treasurePhone} onChange={(val) => setTreasurePhone(val)} inputStyle={{width:245}}></FormStringInput>
                    <FormStringInput label='Email address' value={treasureEmail} onChange={(val) => setTreasureEmail(val)} inputStyle={{width:245}} style={{marginLeft: 15}}></FormStringInput>
                </div>
                <div style={{display:'flex'}}>
                    <FormStringInput label='Address' value={treasureAddress1} onChange={(val) => setTreasureAddress1(val)} inputStyle={{width:245}}></FormStringInput>
                    <FormStringInput label='None' value={treasureAddress2} onChange={(val) => setTreasureAddress2(val)} inputStyle={{width:245}} style={{marginLeft: 15, color:'transparent'}}></FormStringInput>
                </div>
                <div style={{display:'flex'}}>
                    <FormStringInput value={treasureAddress3} onChange={(val) => setTreasureAddress3(val)} inputStyle={{width:245}}></FormStringInput>
                    <FormStringInput value={treasureAddress4} onChange={(val) => setTreasureAddress4(val)} inputStyle={{width:245}} style={{marginLeft: 15}}></FormStringInput>
                </div>
                <FormStringInput value={treasureAddress5} onChange={(val) => setTreasureAddress5(val)} inputStyle={{width:245}}></FormStringInput>
            </WhiteBoard>
            <div>
                <WarningButton caption='Delete branch' isLoading={isDeleting} onClick={() => setShowMessageBox(true)} style={{width:120}}></WarningButton>
                <PrimaryButton caption='Save changes' isLoading={isSaving} onClick={() => onSaveChanges()} style={{width:150, float:'right'}}></PrimaryButton>
            </div>

            { showMessageBox && <MessageBox
                text = 'Are you sure you want to delete this branch?'
                yesText = 'Delete branch'
                noText = 'Cancel'
                isWarning = {true}
                handleClickYes = {() => {
                        deleteBranch();
                    }
                }
                handleClickNo = {() => setShowMessageBox(false)}
            />}
        </StyledTreasureSettings>
    )
}

export default TreasureSettings;